import { render, staticRenderFns } from "./SingleFileUploaderFileManager.vue?vue&type=template&id=476cafa8&scoped=true&"
import script from "./SingleFileUploaderFileManager.vue?vue&type=script&lang=js&"
export * from "./SingleFileUploaderFileManager.vue?vue&type=script&lang=js&"
import style0 from "./SingleFileUploaderFileManager.vue?vue&type=style&index=0&id=476cafa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476cafa8",
  null
  
)

export default component.exports